import { ActivityFeedFragment } from 'services/apollo';
import gql from 'graphql-tag';

export const IntegrationFeedQuery = gql`
  query getIntegrationFeed($cursor: String!, $integrationType: String!, $includeGroups: Boolean!) {
    me {
      activityFeed(
        first: 20
        cursor: $cursor
        integrationType: $integrationType
        includeGroups: $includeGroups
      ) {
        integrationType
        ...activityFeedResults
      }
    }
    integrationSettings(integrationType: $integrationType) {
      title
    }
  }
  ${ActivityFeedFragment}
`;
